import {
  MenuItem as MuiMenuItem,
  MenuItemProps as MuiMenuItemProps
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Text from 'components/Text';

export interface MenuItemProps extends MuiMenuItemProps {
  label: string;
  path?: string;
  /** When set, navigates to this URL (point-o-gms) instead of in-app path */
  externalHref?: string;
  onClick?: () => void;
}

const MenuItem = ({
  label,
  path,
  externalHref,
  onClick,
  ...args
}: MenuItemProps): JSX.Element => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (externalHref) {
      window.location.href = externalHref;
    } else if (path) {
      navigate(path);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <MuiMenuItem onClick={() => handleClick()} {...args}>
      <Text variant="caption">{label}</Text>
    </MuiMenuItem>
  );
};

export default MenuItem;
